<template>
    <div>
        <li class="nav-item dropdown">
            <a class="nav-link font-weight-bold" :style="{color: color.secondary}" href="/app/dashboard" role="button">
                <i class="ni ni-collection" :style="{color: color.secondary}"></i>
                {{ title ? title : $t('common.my_plans')}}
            </a>
        </li>
        <li
            v-if="gamificationRules && gamificationRules.gamification_status"
            class="nav-item dropdown"
        >
            <a class="nav-link font-weight-bold" :style="{color: color.secondary}" href="/app/gamification/score" role="button">
                <i class="mdi mdi-google-controller" :style="{color: color.secondary}"></i>
                {{ $t('common.gamification') }}
            </a>
        </li>
    </div>
</template>

<script>
export default {
    name: "NavbarDashboardIcon",

    props: {
        title: {
            type: String,
            require: false,
            default: null
        },
        gamificationRules: {
            type: Object,
            required: false
        }
    },

    computed: {
        color() {
            return this.$store.getters.COLOR;
        }
    }
};
</script>

<style scoped>
.mdi-google-controller {
  font-size: 20px;
  margin-right: 5px;
}
</style>
